'use client';

import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { isForcedMobileSearch, isSafeonFlutterClient } from './forced-mobile';

const ForcedMobileContext = createContext({ forcedMobile: false, isFlutterClient: false });

function syncRootForcedMobileAttribute(forcedMobile: boolean) {
  if (forcedMobile) {
    document.documentElement.setAttribute('data-forced-mobile', 'true');
    document.body.setAttribute('data-forced-mobile', 'true');
    return;
  }

  document.documentElement.removeAttribute('data-forced-mobile');
  document.body.removeAttribute('data-forced-mobile');
}

export function ForcedMobileProvider({ children, initialForcedMobile, safeonClient }: { children: ReactNode; initialForcedMobile: boolean; safeonClient?: string }) {
  const [forcedMobile] = useState(() => initialForcedMobile || (typeof window !== 'undefined' && isForcedMobileSearch(window.location.search)));

  useEffect(() => {
    syncRootForcedMobileAttribute(forcedMobile);
  }, [forcedMobile]);

  return <ForcedMobileContext.Provider value={{ forcedMobile, isFlutterClient: isSafeonFlutterClient(safeonClient) }}>{children}</ForcedMobileContext.Provider>;
}

export function useForcedMobile() {
  return useContext(ForcedMobileContext).forcedMobile;
}

export function useIsSafeonFlutterClient() {
  return useContext(ForcedMobileContext).isFlutterClient;
}
